export function removeQueryParams(url: string): string {
  if (url.indexOf("?") > 0) {
    return url.substring(0, url.indexOf("?"));
  }

  return url;
}
